<template>
  <div id="sidebar">
    <div id="sidebar-logo">
      <a href="/">
        <img src="../../assets/img/logos/bow.svg" alt="Bow Logo"/>
      </a>
      <Button id="toggle-mobile-menu" @click="toggleMobileMenu">Menu</Button>
    </div>

    <div id="sidebar-menu" :class="{'opened' : mobileMenuOpened}">
      <SidebarLink
        v-if="authenticated"
        title="Add"
        linkTo="/edit/new"
        iconName="icon-square-plus"/>

      <SidebarLink
        v-if="authenticated"
        title="(ToDo) Users group"
        linkTo="#"
        iconName="icon-user-group"/>

      <SidebarLink
        v-if="authenticated"
        title="(ToDo) Shared Users"
        linkTo="#"
        iconName="icon-share"/>

      <SidebarLink
        title="About"
        linkTo="/about"
        iconName="icon-help"/>

      <SidebarLink
        v-if="authenticated && user.admin"
        title="Stats"
        :linkTo="statsUrl"
        iconName="icon-graph"/>

      <SidebarLink
        v-if="authenticated"
        title="(ToDo) Settings"
        linkTo="#"
        iconName="icon-settings"/>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator'
import Button from '@/components/common/Button'
import SidebarLink from '@/components/layout/SidebarLink'

@Component({
  name: 'Sidebar',
  components: {
    Button,
    SidebarLink
  }
})
class Sidebar extends Vue {
  statsUrl = ''
  mobileMenuOpened = false;

  add() {
    this.$router.push({ name: 'Edit', params: { id: 'new' } })
  }

  beforeMount() {
    this.statsUrl = this.$fetch.createUrl('/system/stats')
  }

  toggleMobileMenu() {
    this.mobileMenuOpened = !this.mobileMenuOpened;
  }
}

export default Sidebar
</script>

<style scoped lang="less">
@import '../../assets/less/globals';

#sidebar {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 10;
}

#sidebar-logo {
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: var(--header-height);
  padding: 20px;

  text-align: center;

  border-right: 1px solid var(--color-separation-border);

  img {
    vertical-align: middle;
  }
}

#sidebar-menu {
  position: absolute;
  top: var(--header-height);

  display: none;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  height: calc(100vh - var(--header-height));

  background-color: var(--color-bg-sidebar);
  z-index: 10;

  &.opened {
    display: flex;
    justify-content: space-between;
  }
}

@media screen and (min-width: @screen-desktop-low) {
  #sidebar {
    width: var(--sidebar-width);
    height: 100%;
  }

  #sidebar-logo {
    position: fixed;
    justify-content: center;
    width: var(--sidebar-width);
    background-color: white;
  }

  #sidebar-menu {
    position: relative;

    display: flex;
  }

  #toggle-mobile-menu {
    display: none;
  }
}
</style>
